<!-- studies section start-->
<section class="agency studies studies-bg" id="study"
    [ngStyle]="{'background-image': 'url(assets/images/agency/studies/background.png)'}">
    <div class="container">
        <div class="row">
            <div class="col-md-6 offset-md-3">
                <div class="title">
                    <div class="main-title">
                        <h2 class="text-capitalize text-center">{{'STUDIES.header'|translate}}</h2>
                    </div>
                    <div class="sub-title">
                        <p class="text-center">{{'STUDIES.body'|translate}}</p>
                    </div>
                </div>
            </div>
            <div class="col-12">
                <owl-carousel-o [options]="studiesCarouselOptions">
                    <ng-container *ngFor="let study of studies">
                        <ng-template carouselSlide class="item">
                            <div class="studies-agency">
                                <div class="studies-contain">
                                    <img [src]="study.img" [alt]="study.title" class="img-fluid" loading="lazy">
                                    <div class="img-container center-content">
                                        <div class="center-content">
                                            <div class="studies-info">
                                                <div class="m-b-30">
                                                    <div class="center-text">
                                                        <i class="fa fa-clock-o" aria-hidden="true"></i>
                                                        <h6 class="m-r-25 font-studies">{{study.date}}</h6>
                                                    </div>
                                                </div>
                                                <h2 class="studies-head text-center m-b-30">{{study.title}}</h2>
                                                <p class="para2">{{study.description}}</p>
                                                <div class="m-t-50 m-l-30 link-sound"><a [routerLink]="[study.link]">
                                                        <h2 class="text-black text-uppercase font-weight-light">
                                                            {{study.btn}}</h2>
                                                    </a></div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </ng-template>
                    </ng-container>
                </owl-carousel-o>
            </div>
        </div>
    </div>
</section>
<!-- studies section end-->